import React from "react";

import { Helmet } from "react-helmet";

import './Nyar.css';
import Button from "../../components/button/Button";
import { openReservation } from "../../utils/analytics";

export const Nyar: React.FC = (): JSX.Element => {
    return (
        <>
            <Helmet>
                <title>New years - Hallwylska Restaurang</title>
                <meta name="description" content="Celebrate New Year's Eve 2025 with Hallwylska Restaurang. Join us for a magical evening!" />
                <link rel="canonical" href="https://hallwylskarestaurang.com/nyar" />
                <meta property="og:title" content="Nyår - Hallwylska Restaurang" />
                <meta property="og:description" content="Celebrate New Year's Eve 2025 with Hallwylska Restaurang. Join us for a magical evening!" />
                <meta property="og:url" content="https://hallwylskarestaurang.com/nyar" />
                <meta name="twitter:title" content="Nyår - Hallwylska Restaurang" />
                <meta name="twitter:description" content="Celebrate New Year's Eve 2025 with Hallwylska Restaurang. Join us for a magical evening!" />
                
            </Helmet>
            <section className="nyar beige-bg pt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-xl-4 offset-xl-2 d-flex justify-content-center order-md-1 order-2">
                            <img src="/img/HR_NYE_Table_2025.png"
                                alt="Hallwylska's New Year's Eve celebration"
                                className="mt-1 fly-left nyar__image"/>
                        </div>
                        <div className="col-md-6 col-xl-4 order-md-2 order-1 fly-right">
                            <h1 className="text-green">Hallwylska New Years 2025</h1>
                            <p>Välkommen till en magisk nyårsupplevelse på Hallwylska!</p>
                            
                            <h4 className="nyar__subtitle">Priser & Tider</h4>
                            <div className="nyar__pricing">
                                <p><strong>Middag 1095 kr / 795:- (New Years)</strong><br />
                                19:00 - 02:00</p>
                            </div>
                            
                            <div className="nyar__menus mt-4 mb-4">
                                <h4 className="nyar__subtitle">New Year's Eve Menus</h4>
                                <div className="menu-buttons-vertical">
                                    <Button text="New Year's Eve Menu"
                                        class_type="primary"
                                        onClick={() => window.open('/img/menu/Hallwylksa_NYE_Supé_A5_2025_V1.pdf', '_blank')} />
                                    <Button text="New Year's Eve Cocktail Menu"
                                        class_type="primary"
                                        onClick={() => window.open('/img/menu/HR_NYE_Cocktail_Menu_2025_V2.pdf', '_blank')} />
                                    <Button text="New Year's Eve Wine Menu"
                                        class_type="primary"
                                        onClick={() => window.open('/img/menu/HR_NYE_Wine_Menu_2025_V1.pdf', '_blank')} />
                                </div>
                            </div>
                            
                            <p className="text-center">
                                <Button text='Make a Reservation'
                                        class_type="primary"
                                        onClick={() => openReservation('nyar')}/>
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
  };

